/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FieldRouteImport } from './routes/field'
import { Route as AnalysisAnovaRouteImport } from './routes/analysis/anova'
import { Route as AnalysisLabelsRouteImport } from './routes/analysis/labels'
import { Route as AnalysisRelationsRouteImport } from './routes/analysis/relations'
import { Route as GenealogyAncestorsRouteImport } from './routes/genealogy/ancestors'
import { Route as GenealogyConsistencyRouteImport } from './routes/genealogy/consistency'
import { Route as GenealogyGeneSearchRouteImport } from './routes/genealogy/gene-search'
import { Route as GenealogyGenotypeRouteImport } from './routes/genealogy/genotype'
import { Route as GenealogyImportRouteImport } from './routes/genealogy/import'
import { Route as GenealogyMergeRouteImport } from './routes/genealogy/merge'
import { Route as GenealogyNewSidRouteImport } from './routes/genealogy/new-sid'
import { Route as GenealogyParentPerformanceRouteImport } from './routes/genealogy/parent-performance'
import { Route as GenealogyRegisterRouteImport } from './routes/genealogy/register'
import { Route as GenealogyTreeRouteImport } from './routes/genealogy/tree'
import { Route as GenebankArrivalsRouteImport } from './routes/genebank/arrivals'
import { Route as GenebankGenebankRouteImport } from './routes/genebank/genebank'
import { Route as GenebankPartnersRouteImport } from './routes/genebank/partners'
import { Route as GenebankShipmentsRouteImport } from './routes/genebank/shipments'
import { Route as LabDnaDilutionRouteImport } from './routes/lab/dna-dilution'
import { Route as LabDnaIsolationRouteImport } from './routes/lab/dna-isolation'
import { Route as LabGenetechRouteImport } from './routes/lab/genetech'
import { Route as SeasonCrossingRouteImport } from './routes/season/crossing'
import { Route as SeasonFieldBooksRouteImport } from './routes/season/field-books'
import { Route as SeasonParallelExperimentsRouteImport } from './routes/season/parallel-experiments'
import { Route as SeasonPlotNumberingRouteImport } from './routes/season/plot-numbering'
import { Route as SeasonSelectionRouteImport } from './routes/season/selection'
import { Route as SystemJobsRouteImport } from './routes/system/jobs'
import { Route as SystemJournalRouteImport } from './routes/system/journal'
import { Route as SystemSettingsRouteImport } from './routes/system/settings'
import { Route as TrialsDataRouteImport } from './routes/trials/data'
import { Route as TrialsDataInputRouteImport } from './routes/trials/data-input'
import { Route as TrialsFormulasRouteImport } from './routes/trials/formulas'
import { Route as TrialsImportRouteImport } from './routes/trials/import'
import { Route as TrialsQueriesRouteImport } from './routes/trials/queries'
import { Route as TrialsYearlyRetrieverRouteImport } from './routes/trials/yearly-retriever'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FieldRoute = FieldRouteImport.update({
  id: '/field',
  path: '/field',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysisAnovaRoute = AnalysisAnovaRouteImport.update({
  id: '/analysis/anova',
  path: '/analysis/anova',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysisLabelsRoute = AnalysisLabelsRouteImport.update({
  id: '/analysis/labels',
  path: '/analysis/labels',
  getParentRoute: () => rootRouteImport,
} as any)
const AnalysisRelationsRoute = AnalysisRelationsRouteImport.update({
  id: '/analysis/relations',
  path: '/analysis/relations',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyAncestorsRoute = GenealogyAncestorsRouteImport.update({
  id: '/genealogy/ancestors',
  path: '/genealogy/ancestors',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyConsistencyRoute = GenealogyConsistencyRouteImport.update({
  id: '/genealogy/consistency',
  path: '/genealogy/consistency',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyGeneSearchRoute = GenealogyGeneSearchRouteImport.update({
  id: '/genealogy/gene-search',
  path: '/genealogy/gene-search',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyGenotypeRoute = GenealogyGenotypeRouteImport.update({
  id: '/genealogy/genotype',
  path: '/genealogy/genotype',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyImportRoute = GenealogyImportRouteImport.update({
  id: '/genealogy/import',
  path: '/genealogy/import',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyMergeRoute = GenealogyMergeRouteImport.update({
  id: '/genealogy/merge',
  path: '/genealogy/merge',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyNewSidRoute = GenealogyNewSidRouteImport.update({
  id: '/genealogy/new-sid',
  path: '/genealogy/new-sid',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyParentPerformanceRoute =
  GenealogyParentPerformanceRouteImport.update({
    id: '/genealogy/parent-performance',
    path: '/genealogy/parent-performance',
    getParentRoute: () => rootRouteImport,
  } as any)
const GenealogyRegisterRoute = GenealogyRegisterRouteImport.update({
  id: '/genealogy/register',
  path: '/genealogy/register',
  getParentRoute: () => rootRouteImport,
} as any)
const GenealogyTreeRoute = GenealogyTreeRouteImport.update({
  id: '/genealogy/tree',
  path: '/genealogy/tree',
  getParentRoute: () => rootRouteImport,
} as any)
const GenebankArrivalsRoute = GenebankArrivalsRouteImport.update({
  id: '/genebank/arrivals',
  path: '/genebank/arrivals',
  getParentRoute: () => rootRouteImport,
} as any)
const GenebankGenebankRoute = GenebankGenebankRouteImport.update({
  id: '/genebank/genebank',
  path: '/genebank/genebank',
  getParentRoute: () => rootRouteImport,
} as any)
const GenebankPartnersRoute = GenebankPartnersRouteImport.update({
  id: '/genebank/partners',
  path: '/genebank/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const GenebankShipmentsRoute = GenebankShipmentsRouteImport.update({
  id: '/genebank/shipments',
  path: '/genebank/shipments',
  getParentRoute: () => rootRouteImport,
} as any)
const LabDnaDilutionRoute = LabDnaDilutionRouteImport.update({
  id: '/lab/dna-dilution',
  path: '/lab/dna-dilution',
  getParentRoute: () => rootRouteImport,
} as any)
const LabDnaIsolationRoute = LabDnaIsolationRouteImport.update({
  id: '/lab/dna-isolation',
  path: '/lab/dna-isolation',
  getParentRoute: () => rootRouteImport,
} as any)
const LabGenetechRoute = LabGenetechRouteImport.update({
  id: '/lab/genetech',
  path: '/lab/genetech',
  getParentRoute: () => rootRouteImport,
} as any)
const SeasonCrossingRoute = SeasonCrossingRouteImport.update({
  id: '/season/crossing',
  path: '/season/crossing',
  getParentRoute: () => rootRouteImport,
} as any)
const SeasonFieldBooksRoute = SeasonFieldBooksRouteImport.update({
  id: '/season/field-books',
  path: '/season/field-books',
  getParentRoute: () => rootRouteImport,
} as any)
const SeasonParallelExperimentsRoute =
  SeasonParallelExperimentsRouteImport.update({
    id: '/season/parallel-experiments',
    path: '/season/parallel-experiments',
    getParentRoute: () => rootRouteImport,
  } as any)
const SeasonPlotNumberingRoute = SeasonPlotNumberingRouteImport.update({
  id: '/season/plot-numbering',
  path: '/season/plot-numbering',
  getParentRoute: () => rootRouteImport,
} as any)
const SeasonSelectionRoute = SeasonSelectionRouteImport.update({
  id: '/season/selection',
  path: '/season/selection',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemJobsRoute = SystemJobsRouteImport.update({
  id: '/system/jobs',
  path: '/system/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemJournalRoute = SystemJournalRouteImport.update({
  id: '/system/journal',
  path: '/system/journal',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemSettingsRoute = SystemSettingsRouteImport.update({
  id: '/system/settings',
  path: '/system/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialsDataRoute = TrialsDataRouteImport.update({
  id: '/trials/data',
  path: '/trials/data',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialsDataInputRoute = TrialsDataInputRouteImport.update({
  id: '/trials/data-input',
  path: '/trials/data-input',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialsFormulasRoute = TrialsFormulasRouteImport.update({
  id: '/trials/formulas',
  path: '/trials/formulas',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialsImportRoute = TrialsImportRouteImport.update({
  id: '/trials/import',
  path: '/trials/import',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialsQueriesRoute = TrialsQueriesRouteImport.update({
  id: '/trials/queries',
  path: '/trials/queries',
  getParentRoute: () => rootRouteImport,
} as any)
const TrialsYearlyRetrieverRoute = TrialsYearlyRetrieverRouteImport.update({
  id: '/trials/yearly-retriever',
  path: '/trials/yearly-retriever',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/field': typeof FieldRoute
  '/analysis/anova': typeof AnalysisAnovaRoute
  '/analysis/labels': typeof AnalysisLabelsRoute
  '/analysis/relations': typeof AnalysisRelationsRoute
  '/genealogy/ancestors': typeof GenealogyAncestorsRoute
  '/genealogy/consistency': typeof GenealogyConsistencyRoute
  '/genealogy/gene-search': typeof GenealogyGeneSearchRoute
  '/genealogy/genotype': typeof GenealogyGenotypeRoute
  '/genealogy/import': typeof GenealogyImportRoute
  '/genealogy/merge': typeof GenealogyMergeRoute
  '/genealogy/new-sid': typeof GenealogyNewSidRoute
  '/genealogy/parent-performance': typeof GenealogyParentPerformanceRoute
  '/genealogy/register': typeof GenealogyRegisterRoute
  '/genealogy/tree': typeof GenealogyTreeRoute
  '/genebank/arrivals': typeof GenebankArrivalsRoute
  '/genebank/genebank': typeof GenebankGenebankRoute
  '/genebank/partners': typeof GenebankPartnersRoute
  '/genebank/shipments': typeof GenebankShipmentsRoute
  '/lab/dna-dilution': typeof LabDnaDilutionRoute
  '/lab/dna-isolation': typeof LabDnaIsolationRoute
  '/lab/genetech': typeof LabGenetechRoute
  '/season/crossing': typeof SeasonCrossingRoute
  '/season/field-books': typeof SeasonFieldBooksRoute
  '/season/parallel-experiments': typeof SeasonParallelExperimentsRoute
  '/season/plot-numbering': typeof SeasonPlotNumberingRoute
  '/season/selection': typeof SeasonSelectionRoute
  '/system/jobs': typeof SystemJobsRoute
  '/system/journal': typeof SystemJournalRoute
  '/system/settings': typeof SystemSettingsRoute
  '/trials/data': typeof TrialsDataRoute
  '/trials/data-input': typeof TrialsDataInputRoute
  '/trials/formulas': typeof TrialsFormulasRoute
  '/trials/import': typeof TrialsImportRoute
  '/trials/queries': typeof TrialsQueriesRoute
  '/trials/yearly-retriever': typeof TrialsYearlyRetrieverRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/field': typeof FieldRoute
  '/analysis/anova': typeof AnalysisAnovaRoute
  '/analysis/labels': typeof AnalysisLabelsRoute
  '/analysis/relations': typeof AnalysisRelationsRoute
  '/genealogy/ancestors': typeof GenealogyAncestorsRoute
  '/genealogy/consistency': typeof GenealogyConsistencyRoute
  '/genealogy/gene-search': typeof GenealogyGeneSearchRoute
  '/genealogy/genotype': typeof GenealogyGenotypeRoute
  '/genealogy/import': typeof GenealogyImportRoute
  '/genealogy/merge': typeof GenealogyMergeRoute
  '/genealogy/new-sid': typeof GenealogyNewSidRoute
  '/genealogy/parent-performance': typeof GenealogyParentPerformanceRoute
  '/genealogy/register': typeof GenealogyRegisterRoute
  '/genealogy/tree': typeof GenealogyTreeRoute
  '/genebank/arrivals': typeof GenebankArrivalsRoute
  '/genebank/genebank': typeof GenebankGenebankRoute
  '/genebank/partners': typeof GenebankPartnersRoute
  '/genebank/shipments': typeof GenebankShipmentsRoute
  '/lab/dna-dilution': typeof LabDnaDilutionRoute
  '/lab/dna-isolation': typeof LabDnaIsolationRoute
  '/lab/genetech': typeof LabGenetechRoute
  '/season/crossing': typeof SeasonCrossingRoute
  '/season/field-books': typeof SeasonFieldBooksRoute
  '/season/parallel-experiments': typeof SeasonParallelExperimentsRoute
  '/season/plot-numbering': typeof SeasonPlotNumberingRoute
  '/season/selection': typeof SeasonSelectionRoute
  '/system/jobs': typeof SystemJobsRoute
  '/system/journal': typeof SystemJournalRoute
  '/system/settings': typeof SystemSettingsRoute
  '/trials/data': typeof TrialsDataRoute
  '/trials/data-input': typeof TrialsDataInputRoute
  '/trials/formulas': typeof TrialsFormulasRoute
  '/trials/import': typeof TrialsImportRoute
  '/trials/queries': typeof TrialsQueriesRoute
  '/trials/yearly-retriever': typeof TrialsYearlyRetrieverRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/field': typeof FieldRoute
  '/analysis/anova': typeof AnalysisAnovaRoute
  '/analysis/labels': typeof AnalysisLabelsRoute
  '/analysis/relations': typeof AnalysisRelationsRoute
  '/genealogy/ancestors': typeof GenealogyAncestorsRoute
  '/genealogy/consistency': typeof GenealogyConsistencyRoute
  '/genealogy/gene-search': typeof GenealogyGeneSearchRoute
  '/genealogy/genotype': typeof GenealogyGenotypeRoute
  '/genealogy/import': typeof GenealogyImportRoute
  '/genealogy/merge': typeof GenealogyMergeRoute
  '/genealogy/new-sid': typeof GenealogyNewSidRoute
  '/genealogy/parent-performance': typeof GenealogyParentPerformanceRoute
  '/genealogy/register': typeof GenealogyRegisterRoute
  '/genealogy/tree': typeof GenealogyTreeRoute
  '/genebank/arrivals': typeof GenebankArrivalsRoute
  '/genebank/genebank': typeof GenebankGenebankRoute
  '/genebank/partners': typeof GenebankPartnersRoute
  '/genebank/shipments': typeof GenebankShipmentsRoute
  '/lab/dna-dilution': typeof LabDnaDilutionRoute
  '/lab/dna-isolation': typeof LabDnaIsolationRoute
  '/lab/genetech': typeof LabGenetechRoute
  '/season/crossing': typeof SeasonCrossingRoute
  '/season/field-books': typeof SeasonFieldBooksRoute
  '/season/parallel-experiments': typeof SeasonParallelExperimentsRoute
  '/season/plot-numbering': typeof SeasonPlotNumberingRoute
  '/season/selection': typeof SeasonSelectionRoute
  '/system/jobs': typeof SystemJobsRoute
  '/system/journal': typeof SystemJournalRoute
  '/system/settings': typeof SystemSettingsRoute
  '/trials/data': typeof TrialsDataRoute
  '/trials/data-input': typeof TrialsDataInputRoute
  '/trials/formulas': typeof TrialsFormulasRoute
  '/trials/import': typeof TrialsImportRoute
  '/trials/queries': typeof TrialsQueriesRoute
  '/trials/yearly-retriever': typeof TrialsYearlyRetrieverRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/field'
    | '/analysis/anova'
    | '/analysis/labels'
    | '/analysis/relations'
    | '/genealogy/ancestors'
    | '/genealogy/consistency'
    | '/genealogy/gene-search'
    | '/genealogy/genotype'
    | '/genealogy/import'
    | '/genealogy/merge'
    | '/genealogy/new-sid'
    | '/genealogy/parent-performance'
    | '/genealogy/register'
    | '/genealogy/tree'
    | '/genebank/arrivals'
    | '/genebank/genebank'
    | '/genebank/partners'
    | '/genebank/shipments'
    | '/lab/dna-dilution'
    | '/lab/dna-isolation'
    | '/lab/genetech'
    | '/season/crossing'
    | '/season/field-books'
    | '/season/parallel-experiments'
    | '/season/plot-numbering'
    | '/season/selection'
    | '/system/jobs'
    | '/system/journal'
    | '/system/settings'
    | '/trials/data'
    | '/trials/data-input'
    | '/trials/formulas'
    | '/trials/import'
    | '/trials/queries'
    | '/trials/yearly-retriever'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/field'
    | '/analysis/anova'
    | '/analysis/labels'
    | '/analysis/relations'
    | '/genealogy/ancestors'
    | '/genealogy/consistency'
    | '/genealogy/gene-search'
    | '/genealogy/genotype'
    | '/genealogy/import'
    | '/genealogy/merge'
    | '/genealogy/new-sid'
    | '/genealogy/parent-performance'
    | '/genealogy/register'
    | '/genealogy/tree'
    | '/genebank/arrivals'
    | '/genebank/genebank'
    | '/genebank/partners'
    | '/genebank/shipments'
    | '/lab/dna-dilution'
    | '/lab/dna-isolation'
    | '/lab/genetech'
    | '/season/crossing'
    | '/season/field-books'
    | '/season/parallel-experiments'
    | '/season/plot-numbering'
    | '/season/selection'
    | '/system/jobs'
    | '/system/journal'
    | '/system/settings'
    | '/trials/data'
    | '/trials/data-input'
    | '/trials/formulas'
    | '/trials/import'
    | '/trials/queries'
    | '/trials/yearly-retriever'
  id:
    | '__root__'
    | '/'
    | '/field'
    | '/analysis/anova'
    | '/analysis/labels'
    | '/analysis/relations'
    | '/genealogy/ancestors'
    | '/genealogy/consistency'
    | '/genealogy/gene-search'
    | '/genealogy/genotype'
    | '/genealogy/import'
    | '/genealogy/merge'
    | '/genealogy/new-sid'
    | '/genealogy/parent-performance'
    | '/genealogy/register'
    | '/genealogy/tree'
    | '/genebank/arrivals'
    | '/genebank/genebank'
    | '/genebank/partners'
    | '/genebank/shipments'
    | '/lab/dna-dilution'
    | '/lab/dna-isolation'
    | '/lab/genetech'
    | '/season/crossing'
    | '/season/field-books'
    | '/season/parallel-experiments'
    | '/season/plot-numbering'
    | '/season/selection'
    | '/system/jobs'
    | '/system/journal'
    | '/system/settings'
    | '/trials/data'
    | '/trials/data-input'
    | '/trials/formulas'
    | '/trials/import'
    | '/trials/queries'
    | '/trials/yearly-retriever'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FieldRoute: typeof FieldRoute
  AnalysisAnovaRoute: typeof AnalysisAnovaRoute
  AnalysisLabelsRoute: typeof AnalysisLabelsRoute
  AnalysisRelationsRoute: typeof AnalysisRelationsRoute
  GenealogyAncestorsRoute: typeof GenealogyAncestorsRoute
  GenealogyConsistencyRoute: typeof GenealogyConsistencyRoute
  GenealogyGeneSearchRoute: typeof GenealogyGeneSearchRoute
  GenealogyGenotypeRoute: typeof GenealogyGenotypeRoute
  GenealogyImportRoute: typeof GenealogyImportRoute
  GenealogyMergeRoute: typeof GenealogyMergeRoute
  GenealogyNewSidRoute: typeof GenealogyNewSidRoute
  GenealogyParentPerformanceRoute: typeof GenealogyParentPerformanceRoute
  GenealogyRegisterRoute: typeof GenealogyRegisterRoute
  GenealogyTreeRoute: typeof GenealogyTreeRoute
  GenebankArrivalsRoute: typeof GenebankArrivalsRoute
  GenebankGenebankRoute: typeof GenebankGenebankRoute
  GenebankPartnersRoute: typeof GenebankPartnersRoute
  GenebankShipmentsRoute: typeof GenebankShipmentsRoute
  LabDnaDilutionRoute: typeof LabDnaDilutionRoute
  LabDnaIsolationRoute: typeof LabDnaIsolationRoute
  LabGenetechRoute: typeof LabGenetechRoute
  SeasonCrossingRoute: typeof SeasonCrossingRoute
  SeasonFieldBooksRoute: typeof SeasonFieldBooksRoute
  SeasonParallelExperimentsRoute: typeof SeasonParallelExperimentsRoute
  SeasonPlotNumberingRoute: typeof SeasonPlotNumberingRoute
  SeasonSelectionRoute: typeof SeasonSelectionRoute
  SystemJobsRoute: typeof SystemJobsRoute
  SystemJournalRoute: typeof SystemJournalRoute
  SystemSettingsRoute: typeof SystemSettingsRoute
  TrialsDataRoute: typeof TrialsDataRoute
  TrialsDataInputRoute: typeof TrialsDataInputRoute
  TrialsFormulasRoute: typeof TrialsFormulasRoute
  TrialsImportRoute: typeof TrialsImportRoute
  TrialsQueriesRoute: typeof TrialsQueriesRoute
  TrialsYearlyRetrieverRoute: typeof TrialsYearlyRetrieverRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/field': {
      id: '/field'
      path: '/field'
      fullPath: '/field'
      preLoaderRoute: typeof FieldRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analysis/anova': {
      id: '/analysis/anova'
      path: '/analysis/anova'
      fullPath: '/analysis/anova'
      preLoaderRoute: typeof AnalysisAnovaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analysis/labels': {
      id: '/analysis/labels'
      path: '/analysis/labels'
      fullPath: '/analysis/labels'
      preLoaderRoute: typeof AnalysisLabelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analysis/relations': {
      id: '/analysis/relations'
      path: '/analysis/relations'
      fullPath: '/analysis/relations'
      preLoaderRoute: typeof AnalysisRelationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/ancestors': {
      id: '/genealogy/ancestors'
      path: '/genealogy/ancestors'
      fullPath: '/genealogy/ancestors'
      preLoaderRoute: typeof GenealogyAncestorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/consistency': {
      id: '/genealogy/consistency'
      path: '/genealogy/consistency'
      fullPath: '/genealogy/consistency'
      preLoaderRoute: typeof GenealogyConsistencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/gene-search': {
      id: '/genealogy/gene-search'
      path: '/genealogy/gene-search'
      fullPath: '/genealogy/gene-search'
      preLoaderRoute: typeof GenealogyGeneSearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/genotype': {
      id: '/genealogy/genotype'
      path: '/genealogy/genotype'
      fullPath: '/genealogy/genotype'
      preLoaderRoute: typeof GenealogyGenotypeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/import': {
      id: '/genealogy/import'
      path: '/genealogy/import'
      fullPath: '/genealogy/import'
      preLoaderRoute: typeof GenealogyImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/merge': {
      id: '/genealogy/merge'
      path: '/genealogy/merge'
      fullPath: '/genealogy/merge'
      preLoaderRoute: typeof GenealogyMergeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/new-sid': {
      id: '/genealogy/new-sid'
      path: '/genealogy/new-sid'
      fullPath: '/genealogy/new-sid'
      preLoaderRoute: typeof GenealogyNewSidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/parent-performance': {
      id: '/genealogy/parent-performance'
      path: '/genealogy/parent-performance'
      fullPath: '/genealogy/parent-performance'
      preLoaderRoute: typeof GenealogyParentPerformanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/register': {
      id: '/genealogy/register'
      path: '/genealogy/register'
      fullPath: '/genealogy/register'
      preLoaderRoute: typeof GenealogyRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genealogy/tree': {
      id: '/genealogy/tree'
      path: '/genealogy/tree'
      fullPath: '/genealogy/tree'
      preLoaderRoute: typeof GenealogyTreeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genebank/arrivals': {
      id: '/genebank/arrivals'
      path: '/genebank/arrivals'
      fullPath: '/genebank/arrivals'
      preLoaderRoute: typeof GenebankArrivalsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genebank/genebank': {
      id: '/genebank/genebank'
      path: '/genebank/genebank'
      fullPath: '/genebank/genebank'
      preLoaderRoute: typeof GenebankGenebankRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genebank/partners': {
      id: '/genebank/partners'
      path: '/genebank/partners'
      fullPath: '/genebank/partners'
      preLoaderRoute: typeof GenebankPartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/genebank/shipments': {
      id: '/genebank/shipments'
      path: '/genebank/shipments'
      fullPath: '/genebank/shipments'
      preLoaderRoute: typeof GenebankShipmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/dna-dilution': {
      id: '/lab/dna-dilution'
      path: '/lab/dna-dilution'
      fullPath: '/lab/dna-dilution'
      preLoaderRoute: typeof LabDnaDilutionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/dna-isolation': {
      id: '/lab/dna-isolation'
      path: '/lab/dna-isolation'
      fullPath: '/lab/dna-isolation'
      preLoaderRoute: typeof LabDnaIsolationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lab/genetech': {
      id: '/lab/genetech'
      path: '/lab/genetech'
      fullPath: '/lab/genetech'
      preLoaderRoute: typeof LabGenetechRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/season/crossing': {
      id: '/season/crossing'
      path: '/season/crossing'
      fullPath: '/season/crossing'
      preLoaderRoute: typeof SeasonCrossingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/season/field-books': {
      id: '/season/field-books'
      path: '/season/field-books'
      fullPath: '/season/field-books'
      preLoaderRoute: typeof SeasonFieldBooksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/season/parallel-experiments': {
      id: '/season/parallel-experiments'
      path: '/season/parallel-experiments'
      fullPath: '/season/parallel-experiments'
      preLoaderRoute: typeof SeasonParallelExperimentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/season/plot-numbering': {
      id: '/season/plot-numbering'
      path: '/season/plot-numbering'
      fullPath: '/season/plot-numbering'
      preLoaderRoute: typeof SeasonPlotNumberingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/season/selection': {
      id: '/season/selection'
      path: '/season/selection'
      fullPath: '/season/selection'
      preLoaderRoute: typeof SeasonSelectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/jobs': {
      id: '/system/jobs'
      path: '/system/jobs'
      fullPath: '/system/jobs'
      preLoaderRoute: typeof SystemJobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/journal': {
      id: '/system/journal'
      path: '/system/journal'
      fullPath: '/system/journal'
      preLoaderRoute: typeof SystemJournalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/system/settings': {
      id: '/system/settings'
      path: '/system/settings'
      fullPath: '/system/settings'
      preLoaderRoute: typeof SystemSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trials/data': {
      id: '/trials/data'
      path: '/trials/data'
      fullPath: '/trials/data'
      preLoaderRoute: typeof TrialsDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trials/data-input': {
      id: '/trials/data-input'
      path: '/trials/data-input'
      fullPath: '/trials/data-input'
      preLoaderRoute: typeof TrialsDataInputRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trials/formulas': {
      id: '/trials/formulas'
      path: '/trials/formulas'
      fullPath: '/trials/formulas'
      preLoaderRoute: typeof TrialsFormulasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trials/import': {
      id: '/trials/import'
      path: '/trials/import'
      fullPath: '/trials/import'
      preLoaderRoute: typeof TrialsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trials/queries': {
      id: '/trials/queries'
      path: '/trials/queries'
      fullPath: '/trials/queries'
      preLoaderRoute: typeof TrialsQueriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trials/yearly-retriever': {
      id: '/trials/yearly-retriever'
      path: '/trials/yearly-retriever'
      fullPath: '/trials/yearly-retriever'
      preLoaderRoute: typeof TrialsYearlyRetrieverRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FieldRoute: FieldRoute,
  AnalysisAnovaRoute: AnalysisAnovaRoute,
  AnalysisLabelsRoute: AnalysisLabelsRoute,
  AnalysisRelationsRoute: AnalysisRelationsRoute,
  GenealogyAncestorsRoute: GenealogyAncestorsRoute,
  GenealogyConsistencyRoute: GenealogyConsistencyRoute,
  GenealogyGeneSearchRoute: GenealogyGeneSearchRoute,
  GenealogyGenotypeRoute: GenealogyGenotypeRoute,
  GenealogyImportRoute: GenealogyImportRoute,
  GenealogyMergeRoute: GenealogyMergeRoute,
  GenealogyNewSidRoute: GenealogyNewSidRoute,
  GenealogyParentPerformanceRoute: GenealogyParentPerformanceRoute,
  GenealogyRegisterRoute: GenealogyRegisterRoute,
  GenealogyTreeRoute: GenealogyTreeRoute,
  GenebankArrivalsRoute: GenebankArrivalsRoute,
  GenebankGenebankRoute: GenebankGenebankRoute,
  GenebankPartnersRoute: GenebankPartnersRoute,
  GenebankShipmentsRoute: GenebankShipmentsRoute,
  LabDnaDilutionRoute: LabDnaDilutionRoute,
  LabDnaIsolationRoute: LabDnaIsolationRoute,
  LabGenetechRoute: LabGenetechRoute,
  SeasonCrossingRoute: SeasonCrossingRoute,
  SeasonFieldBooksRoute: SeasonFieldBooksRoute,
  SeasonParallelExperimentsRoute: SeasonParallelExperimentsRoute,
  SeasonPlotNumberingRoute: SeasonPlotNumberingRoute,
  SeasonSelectionRoute: SeasonSelectionRoute,
  SystemJobsRoute: SystemJobsRoute,
  SystemJournalRoute: SystemJournalRoute,
  SystemSettingsRoute: SystemSettingsRoute,
  TrialsDataRoute: TrialsDataRoute,
  TrialsDataInputRoute: TrialsDataInputRoute,
  TrialsFormulasRoute: TrialsFormulasRoute,
  TrialsImportRoute: TrialsImportRoute,
  TrialsQueriesRoute: TrialsQueriesRoute,
  TrialsYearlyRetrieverRoute: TrialsYearlyRetrieverRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
